import {
  Invite as ApiInvite,
  fetchInvite as apiFetchInvite,
} from 'api/invites';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Dispatch, GetState } from '..';
import { setError } from './error';

// Types

export type Invite = ApiInvite & {
  isFetching: boolean;
};
export type State = {
  byId: Record<
    string,
    Invite & {
      isFetching: boolean;
    }
  >;
};

type FetchInviteRequestAction = {
  type: 'FETCH_INVITE_REQUEST';
  inviteId: string;
};
type FetchInviteSuccessAction = {
  type: 'FETCH_INVITE_SUCCESS';
  invite: ApiInvite;
};
export type Action = FetchInviteRequestAction | FetchInviteSuccessAction;

// Reducer

export default function invitesReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: State = {
    byId: {},
  },
  action: Action
) {
  switch (action.type) {
    case 'FETCH_INVITE_REQUEST':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.inviteId]: {
            ...state.byId[action.inviteId],
            id: action.inviteId,
            isFetching: true,
          },
        },
      };

    case 'FETCH_INVITE_SUCCESS':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.invite.id]: { ...action.invite, isFetching: false },
        },
      };

    default:
      // this causes a flow error if there are any unhandled actions
      action as never;

      return state;
  }
}

// Actions

const fetchInviteRequest = (inviteId: string): FetchInviteRequestAction => ({
  type: 'FETCH_INVITE_REQUEST',
  inviteId,
});

const fetchInviteSuccess = (invite: ApiInvite): FetchInviteSuccessAction => ({
  type: 'FETCH_INVITE_SUCCESS',
  invite,
});

export const fetchInvite =
  (inviteId: string) => (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    const invite = state.invites.byId[inviteId];

    if (!invite) {
      dispatch(fetchInviteRequest(inviteId));
      apiFetchInvite(inviteId)
        .then((fetchedInvite) => {
          dispatch(fetchInviteSuccess(fetchedInvite));
        })
        .catch((e) => {
          dispatch(setError(e));
        });
    }
  };
